export default __webpack_public_path__ + "static/applicazioni-ar-vr-ecommerce-1afc7ddf75fdcf457a1370119e1c0318.jpg";